import React from 'react';
import { Inner, Label } from './partials';
export var CurrentSelection = function CurrentSelection(_ref) {
  var open = _ref.open,
    label = _ref.label,
    _onClick = _ref.onClick;
  return React.createElement(Inner, {
    onClick: function onClick() {
      return _onClick();
    },
    open: open
  }, React.createElement(Label, null, label), React.createElement("svg", {
    width: "10",
    height: "8",
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M5 8L0.669873 0.499999L9.33013 0.5L5 8Z",
    fill: "black"
  })));
};